import React from 'react';
import { useFeatureFlags } from '@lms/react-configuration/context/feature-flags';

const FeatureToggler = ({ children, featureName }) => {
    const { features } = useFeatureFlags();
    return (
        <>
            {features?.[featureName] && (
                <>
                    {children}
                </>
            )}
        </>
    );
};

export default FeatureToggler;